import React from 'react';
import Errors from '../../common/components/Errors';
import { Spinner, Intent } from "@blueprintjs/core";

export default function WrappedLoader({ enabled, children, errors, setErrors, state }) {
  if (enabled !== undefined && !enabled) {
    return null;
  }
  if (state.status === 'init') {
    return <Spinner size="200" intent={Intent.SUCCESS} />;
  }
  if (state.status === 'error') {
    return <Errors.Callout errors={errors} setErrors={setErrors} />;
  }
  return children;
}
